import { render, staticRenderFns } from "./Erstinformation.vue?vue&type=template&id=f01dba6c&scoped=true&"
import script from "./Erstinformation.vue?vue&type=script&lang=js&"
export * from "./Erstinformation.vue?vue&type=script&lang=js&"
import style0 from "./Erstinformation.vue?vue&type=style&index=0&id=f01dba6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01dba6c",
  null
  
)

export default component.exports